// Fence Drawing Action names
export const OPEN_FENCE_NAME_DIALOG = 'OPEN_FENCE_NAME_DIALOG';
export const CLOSE_FENCE_NAME_DIALOG = 'CLOSE_FENCE_NAME_DIALOG';
export const RESET_FENCE = 'RESET_FENCE';
export const NEW_FENCE_DRAWN = 'NEW_FENCE_DRAWN';
export const ADD_FENCE = 'ADD_FENCE';
export const DELETE_FENCE = 'DELETE_FENCE';

// Organization Filters
export const SET_ORGANIZATION_FILTER_COUNTRY = 'SET_ORGANIZATION_FILTER_COUNTRY';
export const SET_ORGANIZATION_FILTER_SEARCH_TERM = 'SET_ORGANIZATION_FILTER_SEARCH_TERM';


// Server Action Names
export const RESET_ORGANIZATION = 'RESET_ORGANIZATION';
export const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS';
export const SET_ORGANIZATIONS_SUMMARY = 'SET_ORGANIZATIONS_SUMMARY';
export const SET_ORGANIZATION = 'SET_ORGANIZATION';
export const SAGA_LOAD_ORGANIZATIONS = 'SAGA_LOAD_ORGANIZATIONS';
export const SAGA_CREATE_ORGANIZATION = 'SAGA_CREATE_ORGANIZATION';
export const SAGA_GET_ORGANIZATION_POIS = 'SAGA_GET_ORGANIZATION_POIS';
export const SAGA_GET_ORGANIZATION = 'SAGA_GET_ORGANIZATION';
export const SAGA_LOAD_MAP_FENCES = 'SAGA_LOAD_MAP_FENCES';
export const SAGA_IMPORT_ADDRESSES = 'SAGA_IMPORT_ADDRESSES';
export const SAGA_IMPORT_POIS = 'SAGA_IMPORT_POIS';
export const SAGA_REMOVE_ORGANIZATION = 'SAGA_REMOVE_ORGANIZATION';
export const SAGA_REMOVE_POIS = 'SAGA_REMOVE_POIS';

export const SET_ORGANIZATION_POIS = 'SET_ORGANIZATION_POIS';

// Fence Map Actions Names
export const FENCE_MAP_RESET = 'FENCE_MAP_RESET';
export const FENCE_MAP_CONCAT = 'FENCE_MAP_CONCAT';
export const FENCE_MAP_FENCES_RESET = 'FENCE_MAP_FENCES_RESET';
export const FENCE_MAP_ORGANIZATION_IDS_UPDATE = 'FENCE_MAP_ORGANIZATION_IDS_UPDATE';
export const FENCE_MAP_CATEGORY_IDS_UPDATE = 'FENCE_MAP_CATEGORY_IDS_UPDATE';
export const FENCE_MAP_VIEWPORT_UPDATE = 'FENCE_MAP_VIEWPORT_UPDATE';
export const FENCE_MAP_SHOW_LANDPARCEL_TOGGLE = 'FENCE_MAP_SHOW_LANDPARCEL_TOGGLE';

export const UPDATE_POI_UPLOAD_STATUS = 'UPDATE_POI_UPLOAD_STATUS';
export const POI_UPLOAD_ERROR = 'POI_UPLOAD_ERROR';

// ORGANIZATION SERVER SYNCING

export const setOrganizations = (organizations) => {
	return {
		type: SET_ORGANIZATIONS,
		payload: {
			organizations,
		}
	}
}

export const setOrganizationsSummary = (organizationSummary) => {
	return {
		type: SET_ORGANIZATIONS_SUMMARY,
		payload: {
			organizationSummary,
		}
	}
}

export const resetOrganization = (organizationId) => {
	return {
		type: RESET_ORGANIZATION,
		payload: {
			organizationId,
		}
	}
}

export const setOrganization = (organization) => {
	return {
		type: SET_ORGANIZATION,
		payload: {
			organization,
		}
	}
}


export const serverLoadOrganizations = ()=>{
	return {
		type: SAGA_LOAD_ORGANIZATIONS,
	}
}

export const serverLoadOrganizationPois = (organizationId, searchTerm, page = 0)=>{
	return {
		type: SAGA_GET_ORGANIZATION_POIS,
		payload: {
			organizationId,
			searchTerm,
			page,
		}
	}
}

export const serverLoadOrganization = (organizationId) => {
	return {
		type: SAGA_GET_ORGANIZATION,
		payload: {
			organizationId,
		}
	}
}

export const serverRemoveOrganization = (organizationId) => {
	return {
		type: SAGA_REMOVE_ORGANIZATION,
		payload: {
			organizationId,
		}
	}
}

export const serverRemovePOIs = (poiIds, organizationId) => {
	return {
		type: SAGA_REMOVE_POIS,
		payload: {
			poiIds,
			organizationId,
		}
	}
}

export const serverImportAddresses = (organizationId, addresses = []) => {
	return {
		type: SAGA_IMPORT_ADDRESSES,
		payload: {
			organizationId,
			addresses,
		}
	}
}

export const serverImportPOIs = (organizationId, pois = []) => {
	return {
		type: SAGA_IMPORT_POIS,
		payload: {
			organizationId,
			pois,
		}
	}
}

export const updatePOIUploadStatus = (totalPages, currentPage) => {
	return {
		type: UPDATE_POI_UPLOAD_STATUS,
		payload: {
			totalPages,
			currentPage,
		}
	}
}

export const poiUploadError = (failed) => {
	return {
		type: POI_UPLOAD_ERROR,
		payload: {
			failed,
		}
	}
}

// CREATE NEW FENCES

export const newFence = (type = '', poiId, coordinates = null, overlay = null)=>{
	return{
		type: ADD_FENCE,
		payload: {
			type,
			poiId,
			coordinates,
			overlay,
		}
	}
}

export const deleteFence = (index)=>{
	return{
		type: DELETE_FENCE,
		payload: {
			index: index
		}
	}
}

export const openFenceNameDialog = ()=>{
	return{
		type: OPEN_FENCE_NAME_DIALOG,
	}
}
export const closeFenceNameDialog = ()=>{
	return{
		type: CLOSE_FENCE_NAME_DIALOG,
	}
}

export const resetFence = ()=>{
	return{
		type: RESET_FENCE,
	}
}

export const newFenceDrawn = (fence)=>{
	return {
		type: NEW_FENCE_DRAWN,
		payload: {
			fence,
		}
	}
}

export const setNewFenceMapCenter = (location)=>{
	return {
		type: 'SET_NEW_FENCE_MAP_CENTER',
		payload: {location}
	}
}

export const createOrganization = (organizationObject)=>{
	return{
		type: SAGA_CREATE_ORGANIZATION,
		payload: organizationObject
	}
}

// Organization fences

export const setOrganizationPois = (organizationId, organizationPoiResults, page = 0)=>{
	return{
		type: SET_ORGANIZATION_POIS,
		payload: {organizationId, pois: organizationPoiResults, page}
	}
}


// Fence Map

export const resetFenceMap = ()=>{
	return{
		type: FENCE_MAP_RESET,
	}
}

export const fenceMapConcat = (newFences)=>{
	return {
		type: FENCE_MAP_CONCAT,
		payload:{
			fences: newFences,
		}
	}
}

export const resetFenceMapFences = ()=>{
	return {
		type: FENCE_MAP_FENCES_RESET,
	}
}

export const fenceMapCategoryIdUpdate = (categoryIds) => {
	return {
		type: FENCE_MAP_CATEGORY_IDS_UPDATE,
		payload: {
			categoryIds: categoryIds,
		}
	}
}

export const fenceMapOrganizationIdUpdate = (organizationIds) => {
	return {
		type: FENCE_MAP_ORGANIZATION_IDS_UPDATE,
		payload: {
			organizationIds,
		}
	}
}

export const fenceMapShowLandparcelsToggle = (value) => {
	return {
		type: FENCE_MAP_SHOW_LANDPARCEL_TOGGLE,
		payload: {
			value,
		}
	}
}

export const updateFenceMapViewport = (topLeft, bottomRight)=>{
	return{
		type: FENCE_MAP_VIEWPORT_UPDATE,
		payload: {
			topLeft,
			bottomRight,
		}
	}
}

// Organizations Filters
export const setOrganizationFilterCountry = (country)=>{
	return {
		type: SET_ORGANIZATION_FILTER_COUNTRY,
		payload: {
			country,
		}
	}
}

export const setOrganizationFilterSearchTerm = (searchTerm) => {
	return {
		type: SET_ORGANIZATION_FILTER_SEARCH_TERM,
		payload: {
			searchTerm,
		}
	}
}


// WEBPACK FOOTER //
// ./src/organizations/actions.js